// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__u5enc","Label":"BuildControl_Label__3p4qY","Less":"BuildControl_Less__1io-H","More":"BuildControl_More__m-A6o"};